const BROWSER_ID_KEY = 'auth_m_browser_id';

/**
 * A random id for this browser, kept in localStorage so all of its tabs share
 * it. It is sent when signing in: Auth M keeps the account's session for
 * another tab of this browser, and replaces it (signing the other browser out)
 * for a sign-in from any other browser or device.
 *
 * It names the browser, not a user. Tokens stay per tab (sessionStorage), so
 * different users can still be signed in on different tabs of one browser.
 */
export function browserId(): string {
  try {
    let id = localStorage.getItem(BROWSER_ID_KEY);
    if (!id) {
      id = randomId();
      localStorage.setItem(BROWSER_ID_KEY, id);
    }
    return id;
  } catch {
    // Storage blocked: no lasting id, so this sign-in counts as a new browser.
    return '';
  }
}

function randomId(): string {
  if (typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  // randomUUID needs a secure context; plain-http hosts get the same entropy.
  return Array.from(crypto.getRandomValues(new Uint8Array(16)), (b) => b.toString(16).padStart(2, '0')).join('');
}
